
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4a3428"}},[_c('path',{attrs:{"d":"m12 22c2.6525 0 5.1962-1.0536 7.0713-2.9287s2.9287-4.4188 2.9287-7.0713c0-2.65249-1.0536-5.19618-2.9287-7.07129-1.8751-1.8751-4.4188-2.92871-7.0713-2.92871-2.65249 0-5.19618 1.05363-7.07129 2.92871-1.8751 1.87509-2.92871 4.4188-2.92871 7.07129.00327 2.6508 1.05771 5.1928 2.93289 7.0671 1.87428 1.8751 4.41629 2.9296 7.06711 2.9329zm0-18.04809c2.1333 0 4.1803.84765 5.6892 2.35661 1.5089 1.50891 2.3566 3.5548 2.3566 5.68918 0 2.1333-.8468 4.1802-2.3558 5.6892-1.5089 1.5089-3.5548 2.3566-5.6883 2.3574-2.1342 0-4.18028-.8468-5.68983-2.3558-1.5089-1.508-2.35745-3.5547-2.35745-5.6883.00246-2.13333.8501-4.17857 2.35892-5.68666 1.50808-1.5089 3.55312-2.3566 5.68666-2.35891z"}}),_c('path',{attrs:{"d":"m12.8301 10.7676v5.3935c0 .3737-.0889.6563-.2666.8477-.1778.1914-.4033.2871-.6768.2871-.2734 0-.4967-.098-.6699-.2939-.1686-.196-.2529-.4763-.2529-.8409v-5.3388c0-.3692.0843-.6472.2529-.83402.1732-.18685.3965-.28027.6699-.28027.2735 0 .499.09342.6768.28027.1777.18682.2666.44662.2666.77932zm-.9229-1.92776c-.2597 0-.483-.07975-.6699-.23925-.1823-.15951-.2734-.3851-.2734-.67676 0-.26432.0934-.4808.2802-.64942.1914-.17317.4125-.25976.6631-.25976.2416 0 .4558.07747.6426.23242.1869.15495.2803.38053.2803.67676 0 .28711-.0912.51269-.2735.67676-.1823.1595-.3987.23925-.6494.23925z"}})])])
          )
        }
      }
    